import React from 'react'
import Footer from '../footer/Footer'
import QuizAnswerList from './QuizAnswerList'
import QuizCitiesEndGame from './QuizCitiesEndGame'
import QuizCitiesExplanations from './QuizCitiesExplanations'
import QuizCitiesStartGame from './QuizCitiesStartGame'
import QuizCurrentQuestion from './QuizCurrentQuestion'
import QuizDressing from './QuizDressing'
import s from './QuizMainContent.less'
import QuizTotalScore from './QuizTotalScore'
import { withMapInitialized } from '../map/map.utils.hoc'

const MapReadyContent = withMapInitialized(() => (
  <>
    <QuizCurrentQuestion />
    <QuizCitiesEndGame />
    <QuizTotalScore />
    <QuizAnswerList />
  </>
))

const MapReadyStartGame = withMapInitialized(() => <QuizCitiesStartGame />)

const QuizCitiesMainContent = () => (
  <>
    <div className={s.root}>
      <QuizDressing>
        <MapReadyStartGame />
      </QuizDressing>
      <MapReadyContent />
      <QuizCitiesExplanations />
    </div>
    <Footer />
  </>
)

export default QuizCitiesMainContent
